var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { refreshAccessToken, createUser } from "@airhelp/auth";
import { createUnauthorizedCatcher } from "@airhelp/http-client";
import { useCurrentUserProfile, useWebappHTTPClient } from "@airhelp/webapp/react";
import { useState, useEffect } from "react";
import { useQueryClient, useMutation } from "@tanstack/react-query";
import { useLogin, useLogout, useAuthHTTPClient } from "@airhelp/auth/react";
import { createUser as createUser$1 } from "@airhelp/webapp";
class AuthenticationRequiredError extends Error {
  constructor({
    message,
    returnUrl,
    description
  } = {}) {
    super(message ?? "Authentication required");
    __publicField(this, "returnUrl");
    __publicField(this, "description");
    this.returnUrl = returnUrl;
    this.description = description;
  }
}
function createRefreshAccessTokenUnauthorizedCatcher({
  authClient,
  ...catcherProps
}) {
  return createUnauthorizedCatcher({
    refreshAuth: async () => {
      await refreshAccessToken({ client: authClient });
    },
    onRetryUnauthorized: () => {
      throw new AuthenticationRequiredError();
    },
    ...catcherProps
  });
}
function useSession() {
  const { data, isLoading } = useCurrentUserProfile();
  const [isInitialized, setIsInitialized] = useState(false);
  useEffect(() => {
    if (!isLoading) {
      setIsInitialized(true);
    }
  }, [isLoading]);
  return {
    isInitialized,
    isAuthenticated: Boolean(data == null ? void 0 : data.user),
    user: data == null ? void 0 : data.user
  };
}
function Authenticated({ children }) {
  const { isInitialized, isAuthenticated } = useSession();
  return isInitialized && isAuthenticated ? children : null;
}
function Unauthenticated({ children }) {
  const { isInitialized, isAuthenticated } = useSession();
  return isInitialized && !isAuthenticated ? children : null;
}
function useSignIn(props) {
  const queryClient = useQueryClient();
  return useLogin({
    ...props,
    onSuccess: async (...args) => {
      var _a;
      await queryClient.invalidateQueries({
        queryKey: useCurrentUserProfile.getQueryKey()
      });
      (_a = props == null ? void 0 : props.onSuccess) == null ? void 0 : _a.call(props, ...args);
    }
  });
}
function useSignOut(props) {
  const queryClient = useQueryClient();
  return useLogout({
    ...props,
    onSuccess: async (...args) => {
      var _a;
      await queryClient.resetQueries({
        queryKey: useCurrentUserProfile.getQueryKey(),
        exact: true
      });
      await queryClient.invalidateQueries();
      (_a = props == null ? void 0 : props.onSuccess) == null ? void 0 : _a.call(props, ...args);
    }
  });
}
function useSignUp(props) {
  const queryClient = useQueryClient();
  const authClient = useAuthHTTPClient();
  const webappClient = useWebappHTTPClient();
  return useMutation({
    ...props,
    mutationFn: async (data) => {
      const auth = await createUser({
        client: authClient,
        params: { email: data.user.email, password: data.user.password }
      });
      const webapp = await createUser$1({
        client: webappClient,
        params: data
      });
      return { auth, webapp };
    },
    onSuccess: async (...args) => {
      var _a;
      await queryClient.resetQueries({
        queryKey: useCurrentUserProfile.getQueryKey()
      });
      (_a = props == null ? void 0 : props.onSuccess) == null ? void 0 : _a.call(props, ...args);
    }
  });
}
export {
  Authenticated,
  AuthenticationRequiredError,
  Unauthenticated,
  createRefreshAccessTokenUnauthorizedCatcher,
  useSession,
  useSignIn,
  useSignOut,
  useSignUp
};
//# sourceMappingURL=index.js.map
